// src/components/GlobalLoader.js
import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

export default function GlobalLoader({ open }) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
